module.exports = __webpack_public_path__ + "static/images/refuse.d867183.png";